import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=68fd3eec&"
import script from "./standard.vue?vue&type=script&lang=js&"
export * from "./standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports